import { CircleButton } from 'pages/Shifts/Shifts.styled'
import { Flex } from 'styling/GlobalStyles'
import { SquareCheckBox } from './CheckBox.styled'
import { OtherText } from 'styling/Typography'
import { CheckBoxIcon } from './CheckBoxIcon'

export const CheckBox = ({
  state,
  onClick,
  title,
  square
}: {
  state: boolean
  onClick?: () => void
  title: string
  square?: boolean
}) => {
  return (
    <Flex center gap='1rem' width='100%' height='1.5rem' onClick={onClick}>
      {square ? <SquareCheckBox active={state}>
        {state && <CheckBoxIcon />}
      </SquareCheckBox> : <CircleButton checked={state} />}
      <OtherText>{title}</OtherText>
    </Flex>
  )
}
